<template>
    <div class="main-app">
        <InvoiceDiscount
            :discount="discount"
            @update:discount="updateDiscount"
        />
        <CompanyInfo :variant="variant" :logo="logo" />
        <div class="row big-top-margin">
            <InvoiceDetails :variant="variant" :currency="getCurrency" />
        </div>
        <div class="row">
            <InvoiceItems
                :variant="variant"
                :currency="getCurrency"
                :discount="discount"
            />
        </div>
    </div>
</template>

<script>
import CompanyInfo from './CompanyInfo.vue';
import InvoiceItems from './InvoiceItems.vue';
import InvoiceDetails from './InvoiceDetails.vue';
import currencyFormatter from 'currency-formatter';
import InvoiceDiscount from './InvoiceDiscount.vue';

export default {
    name: 'app-Invoice',
    props: {
        invoice: {
            type: Object,
        },
        company: {
            type: Object,
        },
        customer: {
            type: Object,
        },
        logo: {
            default: '',
            type: String,
        },
        variant: {
            type: Number,
            default: 1,
        },
        currency: { default: 'USD', type: String },
    },
    components: {
        CompanyInfo,
        InvoiceItems,
        InvoiceDetails,
        InvoiceDiscount,
    },
    data() {
        return {
            currencies: null,
            discount: {
                total: 1.0,
                cloudfront: {
                    'US East (N. Virginia)': null,
                    'Asia Pacific (Singapore)': null,
                    'Asia Pacific (Sydney)': null,
                    'Canada (Central)': null,
                    'South America (São Paulo)': null,
                    'Middle East (Bahrain)': null,
                    'Africa (Cape Town)': null,
                    'Asia Pacific (Tokyo)': null,
                    'EU (Ireland)': null,
                    'Asia Pacific (Mumbai)': null,
                },
            },
        };
    },
    computed: {
        getCurrency() {
            if (this.currencies) {
                return Object.keys(this.currencies)
                    .filter((cur) => {
                        return (
                            this.currencies[cur].code ==
                            this.currency.toUpperCase()
                        );
                    })
                    .map((key) => {
                        return this.currencies[key];
                    })
                    .reduce((obj) => obj);
            } else {
                return {
                    code: 'USD',
                    symbol: '$',
                };
            }
        },
    },
    watch: {
        discount: {
            handler: function (val) {
                this.$store.dispatch('setDiscountRate', val);
            },
            deep: true,
        },
    },
    mounted() {
        this.$store.dispatch('addInvoice', this.invoice);
        this.$store.dispatch('addCustomer', this.customer);
        this.$store.dispatch('addCompany', this.company);
        this.currencies = currencyFormatter.currencies;
    },
    methods: {
        updateDiscount(discount) {
            if (discount) {
                this.discount = discount;
            } else {
                this.discount = {
                    total: 1.0,
                    cloudfront: {
                        'US East (N. Virginia)': null,
                        'Asia Pacific (Singapore)': null,
                        'Asia Pacific (Sydney)': null,
                        'Canada (Central)': null,
                        'South America (São Paulo)': null,
                        'Middle East (Bahrain)': null,
                        'Africa (Cape Town)': null,
                        'Asia Pacific (Tokyo)': null,
                        'EU (Ireland)': null,
                        'Asia Pacific (Mumbai)': null,
                    },
                };
            }
        },
    },
};
</script>

<style lang="scss">
@import 'main';
.main-app {
    font-size: $font-normal;
    padding: 4rem 5rem;
    width: 100%;
    @media only screen and (max-width: 768px) {
        margin: auto;
    }
}

* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

.invoice {
    display: flex;

    &:not(:last-child) {
        flex-basis: auto;
    }
}

.row {
    row {
        display: -ms-flexbox;
        display: -webkit-box;
        display: flex;
        -ms-flex-wrap: wrap;
        flex-wrap: wrap;
        // margin-right: -15px;
        // margin-left: -15px;
    }
}

.inv-table {
    & thead {
        & tr {
            // background-color: $color-primary-light;
            text-align: right;

            & th {
                border-top: none;
                color: $color-grey-light !important;
                background-color: inherit !important;
                font-weight: $font-weight-bold;
                padding: 1.1rem;
                margin-bottom: 1rem;
                border-bottom: 1px;

                &:first-of-type {
                    text-align: left;
                }
            }
        }
    }

    & tbody {
        & tr:not(:first-of-type) td {
            border-top: none;
        }

        & tr {
            & td {
                padding: 2rem;
                border-bottom: solid 1px $color-grey-light;
                text-align: right;
                &:first-of-type {
                    text-align: left;
                }
            }
        }
    }
}
</style>
